import React from "react";

import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { Boundary, Placement, PositioningStrategy } from "@popperjs/core";

import { Icon } from "./Icon";
import { Tooltip } from "./Tooltip";

export type InfoIconProps = Pick<FontAwesomeIconProps, "size" | "color"> & {
  closeOnMouseLeaveDelay?: number;
  content: React.ReactNode;
  customBoundary?: Boundary | React.RefObject<HTMLInputElement>;
  offset?: number[];
  placement?: Placement;
  tooltipIcon?: IconName;
  strategy?: PositioningStrategy;
};

export const InfoIcon: React.FC<InfoIconProps> = ({
  closeOnMouseLeaveDelay,
  color,
  content,
  customBoundary,
  offset,
  placement,
  size = "1x",
  tooltipIcon,
  strategy
}) => {
  return (
    <Tooltip
      closeOnMouseLeaveDelay={closeOnMouseLeaveDelay}
      strategy={strategy}
      placement={placement}
      offset={offset}
      customBoundary={customBoundary}
      content={content}
    >
      <span>
        &nbsp;
        <Icon color={color} name={tooltipIcon ? tooltipIcon : "question-circle"} size={size} />
      </span>
    </Tooltip>
  );
};
